var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"modal__cape",on:{"click":_vm.close}}),_c('div',{staticClass:"modal__box"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }